var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-10"},[_c('div',{ref:"lateTransporter",staticStyle:{"height":"400px"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }